import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons/faCheckCircle";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import { faMinusCircle } from "@fortawesome/free-solid-svg-icons/faMinusCircle";
import { VerificationTransactionDetailsPolicyDecisionConditionResult } from "@idw-types/data/verification-transaction-details";
import { useState } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import styles from "./policy-decision-condition-results-container.less";
import classNames from "classnames";
import { PolicyDecisionConditionResultDiagram } from "../policy-decision-condition-result-diagram/policy-decision-condition-result-diagram";

type PolicyDecisionConditionsResultsContainerProps = {
    policyDecisionConditionResults: Array<VerificationTransactionDetailsPolicyDecisionConditionResult>;
};

export const PolicyDecisionConditionsResultsContainer = (props: PolicyDecisionConditionsResultsContainerProps) => {
    const { policyDecisionConditionResults } = props;

    const [selectedConditionResult, setSelectedConditionResult] = useState<VerificationTransactionDetailsPolicyDecisionConditionResult>(null);

    const renderPassOverlay = (props: any) => {
        return <Tooltip {...props}>This did not contribute to a deny or obligation result</Tooltip>;
    };

    const renderFailOverlay = (props: any) => {
        return <Tooltip {...props}>This contributed to a deny or obligation result</Tooltip>;
    }

    const renderDefaultOverlay = (props: any) => {
        return <Tooltip {...props}>This did not contribute positively or negatively to the result</Tooltip>
    };

    const conditionResultIcon = (policyDecisionConditionResult: VerificationTransactionDetailsPolicyDecisionConditionResult) => {
        switch (policyDecisionConditionResult.result) {
            case "pass":
                return (
                    <OverlayTrigger overlay={renderPassOverlay}>
                        <span>
                            <FontAwesomeIcon className={styles.passIcon} icon={faCheckCircle} />
                        </span>
                    </OverlayTrigger>
                );
            case "fail":
                return (
                    <OverlayTrigger overlay={renderFailOverlay}>
                        <span>
                            <FontAwesomeIcon className={styles.failIcon} icon={faTimesCircle} />
                        </span>
                    </OverlayTrigger>
                );
            default:
                return (
                    <OverlayTrigger overlay={renderDefaultOverlay}>
                        <span>
                            <FontAwesomeIcon className={styles.defaultIcon} icon={faMinusCircle} />
                        </span>
                    </OverlayTrigger>
                );
        }
    };

    const onClickConditionResult = (conditionResult: VerificationTransactionDetailsPolicyDecisionConditionResult) => {
        if (selectedConditionResult && selectedConditionResult.name === conditionResult.name) {
            setSelectedConditionResult(null);
        } else {
            setSelectedConditionResult(conditionResult);
        }
    };

    return (
        <div className={styles.policyDecisionConditionResultsContainer}>
            <div className={styles.policyDecisionConditionResultsList}>
                {policyDecisionConditionResults.map(result => (
                    <button
                        key={`policy-decision-condition-result-${result.name}`}
                        className={classNames(styles.policyDecisionConditionResult, selectedConditionResult?.name === result.name ? styles.selected : "")}
                        onClick={() => onClickConditionResult(result)}
                    >
                        <span>{result.name}</span>
                        <div className={styles.iconContainer}>{conditionResultIcon(result)}</div>
                    </button>
                ))}
            </div>
            <div className={styles.policyDecisionConditionResultExplanationContainer}>
                {selectedConditionResult ? (
                    <>
                        <span className={styles.explanationTitle}>Detailed View</span>
                        <PolicyDecisionConditionResultDiagram
                            policyDecisionConditionResult={selectedConditionResult}
                            depth={0}
                            index={0}
                            siblingCount={0}
                            parentPolicyDecisionConditionResult={null}
                            andOrTextBackgroundColor={"#eee"}
                        />
                    </>
                ) : (
                    <span className={styles.selectConditionResultText}>Please click on an assertion to view more details</span>
                )}
            </div>
        </div>
    );
};